/**
 * Quatre exemples, pas plus : ils disent ce que l'assistant sait faire
 * mieux qu'un mode d'emploi, une par famille du catalogue (lecture, lecture,
 * déclenchement, écriture). Aucun nom réel de dossier ni de personne : ces
 * lignes sont lues par tous les cabinets (verdict sécurité du 11/09/2026).
 * Cliquées, elles font demander à l'assistant de quel dossier il s'agit.
 */
const EXEMPLES = [
  'Quels dossiers n’ont pas leur DSN du mois dernier ?',
  'Récupère-moi les bulletins du mois dernier d’un dossier',
  'Lance le calcul des bulletins d’un dossier',
];
/** Proposé seulement si le serveur a ouvert l'écriture : pas d'exemple qu'il refuserait. */
const EXEMPLE_ECRITURE = 'Modifie l’adresse d’un salarié';

export function Suggestions({
  onChoisir,
  ecriture,
}: {
  onChoisir: (texte: string) => void;
  ecriture: boolean;
}) {
  const exemples = ecriture ? [...EXEMPLES, EXEMPLE_ECRITURE] : EXEMPLES;
  return (
    <div className="flex flex-wrap gap-3">
      {exemples.map(exemple => (
        <button
          key={exemple}
          type="button"
          onClick={() => onChoisir(exemple)}
          className="hover:border-brand-300 hover:bg-brand-50 min-h-9 rounded-full border border-neutral-200 bg-white px-3 py-2 text-sm leading-5 text-neutral-700 transition-colors"
        >
          {exemple}
        </button>
      ))}
    </div>
  );
}
